/** FAQ content — client-supplied. Homepage uses questions 1–6, /faqs uses all. */
// COPY LOCKED — do not paraphrase without client confirmation. See /app/memory/PRD.md.

export const ALL_FAQS = [
    {
        q: "Is the design really free?",
        a: "Yes. There is no professional design fee for the agreed free-design scope. The service is subject to project feasibility.",
    },
    {
        q: "Do I have to use you for the construction?",
        a: "No. There is no obligation to appoint us to carry out the construction work.\n\nIf you decide to use another contractor, no retrospective design fee becomes payable simply because you choose another builder.",
    },
    {
        q: "What does the free design service include?",
        a: "The service covers architectural concept and layout development through to a level of detail typically prepared for a planning application.\n\nThe exact scope will depend on the property and proposed works.",
    },
    {
        q: "Is a measured survey included?",
        a: "Where suitable, yes.\n\nFor properties within our local service area, we may be able to undertake a measured survey as part of the free design service.\n\nThis will depend on the project location, property and scope of works.",
    },
    {
        q: "Does the free service include a planning application?",
        a: "The free service covers design development to planning-application level.\n\nPlanning submission, planning management, statutory fees and specialist consultant services are not automatically included unless expressly agreed.",
    },
    {
        q: "What happens if I use another builder?",
        a: "You are free to take the issued design forward with another contractor.\n\nThere is no retrospective design fee simply because you choose another builder.",
    },
    {
        q: "What types of project are suitable?",
        a: "Rear extensions, side extensions, loft conversions/extensions and internal reconfigurations.",
    },
    {
        q: "Where do you work?",
        a: "We primarily work across West, North-West and South-West London, together with selected surrounding areas including parts of Surrey.",
    },
    {
        q: "How do you decide whether a project is feasible?",
        a: "Every property and project is different.\n\nWe consider the property, proposed scope, planning and design considerations, budget, programme and overall deliverability.",
    },
    {
        q: "How long does the design process take?",
        a: "Timescales depend on the project scope, the information available at the start, whether a measured survey is required, and how quickly design feedback can be exchanged.\n\nWe can give you a more specific indication once we understand the property and the works you are considering. We prefer not to promise a fixed turnaround before we have reviewed your project.",
    },
    {
        q: "Are revisions included?",
        a: "Reasonable design development is included as part of reaching an agreed proposal.\n\nWe do not advertise a fixed number of revisions; the aim is to arrive at a design you are happy to take forward.",
    },
    {
        q: "Are structural calculations included?",
        a: "No. Structural engineering and calculations are separate specialist services unless expressly agreed.",
    },
    {
        q: "Are Building Regulations drawings included?",
        a: "No. Technical construction information and Building Regulations packages are not automatically included within the free-design scope.",
    },
    {
        q: "Are Party Wall services included?",
        a: "No, unless expressly agreed.",
    },
    {
        q: "Are planning application fees included?",
        a: "No. Local authority and other statutory fees are not included.",
    },
    {
        q: "Are other consultants included?",
        a: "Specialist consultants, surveys, reports and third-party services are not included unless expressly agreed.",
    },
    {
        q: "Can I build directly from the free drawings?",
        a: "The drawings provided as part of the design service are architectural concept/planning-level information unless expressly stated otherwise.\n\nAppropriate technical design, structural information and Building Regulations information may be required before construction.",
    },
    {
        q: "Who owns the drawings?",
        a: "Copyright remains with the designer.\n\nOnce issued, the homeowner receives a royalty-free licence to use the drawings in connection with the relevant property, including if they subsequently appoint another designer or contractor.",
    },
];

export const HOMEPAGE_FAQS = ALL_FAQS.slice(0, 6);
